import styled from 'styled-components'

import { helpers } from 'styles'

export const ColumnLabel = styled.div`
	display: block;
	position: relative;
	font-size: ${helpers.font.size.small};
`
